// @ts-strict-ignore
import React from 'react'
import { classList, StandardWidth } from 'services/styles'
import PageContext from '../context'
import useStyles from './styles'

export interface IPageProps {
  children?: React.ReactNode
  className?: string
  style?: React.CSSProperties
}

function Page(props: IPageProps) {
  const { classes } = useStyles()
  const { className, children, ...restProps } = props
  const [secondarySidebarCount, setSecondarySidebarCount] = React.useState(0)
  const [secondarySidebarOpen, setSecondarySidebarOpen] = React.useState(false)
  const [requiredSidebarWidth, setRequiredSidebarWidth] = React.useState<StandardWidth>('lg')

  const setRequiredSidebarWidthIfDifferent = React.useCallback((width: StandardWidth) => {
    if (width !== requiredSidebarWidth) {
      setRequiredSidebarWidth(width)
    }
  }, [requiredSidebarWidth])

  const incrementPageSidebarCount = React.useCallback(() => {
    setSecondarySidebarCount(count => count + 1)
  }, [])

  const decrementPageSidebarCount = React.useCallback(() => {
    setSecondarySidebarCount(count => Math.max(0, count - 1))
  }, [])

  return (
    <div className={classList(classes.container, className)} {...restProps}>
      <PageContext.Provider
        value={{
          hasSecondarySidebar: (secondarySidebarCount > 0),
          secondarySidebarOpen: secondarySidebarOpen,
          requiredSidebarWidth: requiredSidebarWidth,
          setSecondarySidebarOpen: setSecondarySidebarOpen,
          setRequiredSidebarWidth: setRequiredSidebarWidthIfDifferent,
          incrementPageSidebarCount: incrementPageSidebarCount,
          decrementPageSidebarCount: decrementPageSidebarCount,
        }}
      >
        {children}
      </PageContext.Provider>
    </div>
  )
}

export default React.memo(Page)
